import { ru } from "date-fns/locale";
import { forwardRef } from "react";
import { Button } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import Icon from './Icon';
import { faCalendar as calendarOutline } from '@fortawesome/free-solid-svg-icons';

import "react-datepicker/dist/react-datepicker.css";

registerLocale("ru", ru);

// Стили для отображения календаря поверх sticky-элементов
const datePickerStyles = `
    .react-datepicker-wrapper {
        z-index: auto !important;
    }
    .react-datepicker-popper {
        z-index: 100000 !important;
    }
    .react-datepicker__portal {
        z-index: 100000 !important;
    }
`;

type ExampleCustomInputProps = {
    className?: string;
    value?: string;
    onClick?: () => void;
    icon?: any
    title?: string,
    inputProps?: any
};

const CalendarButtonInput = forwardRef<
    HTMLButtonElement,
    ExampleCustomInputProps
>(({ value, onClick, className, icon = calendarOutline, title, inputProps }, ref) => (
    <Button title={title} size="sm" variant={inputProps?.variant || "outline-secondary"} className={className} onClick={onClick} ref={ref} style={{ borderRadius: 0 }} {...inputProps || {}}>
        <Icon icon={icon} />
    </Button>
));
CalendarButtonInput.displayName = "ExampleCustomInput";

const ButtonDatePicker: React.FC<{ onSelect: (date: Date | null, event?: any) => void, date: Date, icon?: any, title?: string, inputProps?: any }> = ({ onSelect, date, icon, title, inputProps }) => {


    return (
        <>
            <style>{datePickerStyles}</style>
            <DatePicker
                onChange={onSelect}
                selected={date}
                locale="ru"
                title={title}
                customInput={<CalendarButtonInput icon={icon} title={title} inputProps={inputProps} />}
                popperPlacement="bottom-start"
                portalId="root-portal"
            />
        </>
    );
};

export default ButtonDatePicker;